var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65304 18.6368L10.1793 19.8203C10.4989 20.54 11.2125 21.0038 12 21.0038V21.0038C12.7875 21.0038 13.5012 20.54 13.8208 19.8203L14.347 18.6368C14.5343 18.2168 14.8494 17.8667 15.2474 17.6364V17.6364C15.6478 17.4054 16.1111 17.307 16.5709 17.3553L17.8585 17.4923C18.6415 17.5751 19.3998 17.1889 19.7933 16.5069V16.5069C20.1872 15.8253 20.1425 14.9755 19.6792 14.339L18.9169 13.2916C18.6455 12.9158 18.5004 12.4635 18.5027 12V12C18.5026 11.5378 18.649 11.0874 18.9209 10.7135L19.6832 9.66605C20.1465 9.02954 20.1913 8.17976 19.7973 7.49815V7.49815C19.4038 6.81613 18.6455 6.42991 17.8625 6.51274L16.5749 6.64979C16.1151 6.69808 15.6518 6.59968 15.2514 6.36868V6.36868C14.8526 6.13701 14.5374 5.78506 14.351 5.36326L13.8208 4.17977C13.5012 3.46002 12.7875 2.99627 12 2.99627V2.99627C11.2125 2.99627 10.4989 3.46002 10.1793 4.17977L9.65304 5.36326C9.4666 5.78506 9.15142 6.13701 8.75267 6.36868V6.36868C8.35219 6.59968 7.88891 6.69808 7.42911 6.64979L6.13758 6.51274C5.35456 6.42991 4.59625 6.81613 4.20277 7.49815V7.49815C3.80878 8.17976 3.85349 9.02954 4.31682 9.66605L5.07914 10.7135C5.351 11.0874 5.49739 11.5378 5.49731 12V12C5.49739 12.4623 5.351 12.9127 5.07914 13.2866L4.31682 14.334C3.85349 14.9705 3.80878 15.8203 4.20277 16.5019V16.5019C4.59661 17.1835 5.35466 17.5696 6.13758 17.4873L7.42511 17.3503C7.88491 17.302 8.34819 17.4004 8.74866 17.6314V17.6314C9.14891 17.8624 9.46555 18.2144 9.65304 18.6368V18.6368Z",
    stroke: "#003541",
    strokeOpacity: 0.4,
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.6481,
    stroke: "#003541",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsIcon);
export default __webpack_public_path__ + "static/media/applications-icon.df2878f05f1ed8f90c3e4d3f3d635b54.svg";
export { ForwardRef as ReactComponent };